import DownpaymentSupportedAssociations from '@/components/downpayment/DownpaymentSupportedAssociations'

export default {
    install(Vue) {
        Vue.component("DownpaymentSupportedAssociations", DownpaymentSupportedAssociations)
    }
}
